import i18n from 'i18next';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { Action } from '../base/fsa/createAction';
import { RPCService } from '../service/rpc-service';
import { setDefaultAlarmStateAction, setDeviceVersionListResponse, setEnergyAnalyzer, setEntityListAction, setExternalUsbAction, setHomepageItemsActions, setLogAction, setMessageNotification, setMousePointerAction, setOnboardingListAction, setSoundStateAction, setSuntimeAction, setSystemRestartAction, setTimezoneAction, setWorkerConfigPanelAction } from '../store/control/actions';
import { setInitialEntityListAction } from '../store/control/actions';
import {
  ConfigModel,
  LanguageModel,
} from "../store/control/state";
import { setSettingsAction } from '../store/settings/actions';
import { setTemperatureAction } from '../store/temperature/action';
import { setApplicationLoaded, setMediaFileListAction, setThemeAction } from '../store/ui/actions';
import { store } from '../store';
import { setSupervisorConfigListAction } from '../store/control/actions';
import { setWorkerConfig } from '../store/control/actions';
import { ApplicationState } from '../store/reducer';
import { SupervisorConfigModel } from '../types/supervisor-config'
import { WorkerConfigModel } from '../types/worker-config'


let latestVersion = localStorage.getItem('latestVersion');
//let preventReload = localStorage.getItem('preventReload') === 'true';
export async function fetchAndInitialize(rpc_service: RPCService, dispatch: Dispatch<Action>) {
  const sensorTypePromise = rpc_service.getSensorTypeList();
  const controlTypePromise = rpc_service.getControlTypeList();
  const userPromise = rpc_service.getUserList();
  const controlPromise = rpc_service.getControlList();
  const bridgeDevicePromise = rpc_service.getBridgeDeviceList();
  const bridgeDeviceTypePromise = rpc_service.getBridgeDeviceTypeList();
  const gatewayPromise = rpc_service.getGatewayList();
  const cameraPromise = rpc_service.getCameraList();
  const cameraBrandPromise = rpc_service.getCameraBrandList();
  const mediaFilePromise = rpc_service.getMediaFileList();
  const inputTypePromise = rpc_service.getInputTypeList();
  const inputPromise = rpc_service.getInputList();
  const scenarioPromise = rpc_service.getScenarioList();
  const scenarioTriggerPromise = rpc_service.getScenarioTriggerList();
  const doorPromise = rpc_service.getDoorList();
  const doorBrandPromise = rpc_service.getDoorBrandList();
  const intercomPromise = rpc_service.getIntercomList();
  const areaPromise = rpc_service.getAreaList();
  const mediaPromise = rpc_service.getMediaList();
  const mediaInputPromise = rpc_service.getMediaInputList();
  const virtualControlPromise = rpc_service.getVirtualControlList();
  const homepageItemPromise = rpc_service.getHomepageItemList();
  const alarmStatePromise = rpc_service.getAlarmState();
  const soundStatePromise = rpc_service.getSoundState();
  const screenStatePromise = rpc_service.getScreenState();
  const settingsPromise = rpc_service.getSettings();
  const configsPromise = rpc_service.getConfigs();
  const locationPromise = rpc_service.getLocationList();
  const temperaturePromise = rpc_service.getTemperature();
  const menuItemPromise = rpc_service.getMenuList();
  const stpUIPromise = rpc_service.getSTPUIList();
  const panelLanguagePromise = rpc_service.getPanelLanguage();
  const languagePromise = rpc_service.getLanguageList();
  const conciergePromise = rpc_service.getConciergeList();
  const conciergeTypePromise = rpc_service.getConciergeTypeList();
  const getLogListPromise = rpc_service.GetLogList();
  const iftttStatePromise = rpc_service.getIftttState();
  const getScreenPinPromise = rpc_service.getScreenPinCodeState();
  const getEnergyStatePromise = rpc_service.getEnergyMonitorGetConfig();
  //const getConnectionIconsPromise = rpc_service.GetConnIcons()
  //const getSupervisorConfigPromise = rpc_service.getSupConfig();
  //const getWorkerConfigPromise = rpc_service.getWorkerConfig();
  const role = (store.getState() as ApplicationState).ui.role;
  let getSupervisorConfigPromise: Promise<SupervisorConfigModel | null> = Promise.resolve(null);
  let getWorkerConfigPromise: Promise<WorkerConfigModel | null> = Promise.resolve(null);
  if (role === 'developer') {
    getSupervisorConfigPromise = rpc_service.getSupConfig();
    getWorkerConfigPromise = rpc_service.getWorkerConfig();
  }
  const getCallListPromise = rpc_service.getCallList();
  const getMousePointerPromise = rpc_service.getMouseCursorVisibility();
  const getAuthorityGroupListPromise = rpc_service.getAuthorityGroupList();
  const getHomepageItemsPromise = rpc_service.getHomepageItemsByGatewayStatus();
  const getExternalUsbPromise = rpc_service.getUsbConnectionStatus();
  const getTimezonePromise = rpc_service.getTimezoneList();
  const getAsyncAlarmTimerPromise = rpc_service.getAlarmTimerState();
  const getSIPBlockedListPromise = rpc_service.getCallBlockList();
  const getBoosterDeviceListPromise = rpc_service.getBoostedDeviceList();
  const getSIPFormatTypePromise = rpc_service.getSipFormatList();
  const getSuntimePromise = rpc_service.getSunriseSunset();
  const getFrameUIListPromise = rpc_service.getFrameUIList();
  const getUIThemePromise = rpc_service.getUITheme();
  const getLucentRGBSettingsPromise = rpc_service.getLucentRGBSettings();
  const getAnalogSensorTypeListPromise = rpc_service.getAnalogSensorTypeList();
  const getAllHardwareDeviceVersionsPromise = rpc_service.getAllHardwareDeviceVersions()
  const getMessageListPromise = rpc_service.GetMessageList();
  const getSystemRestartPromise = rpc_service.getSystemRestartSettings();
  const getWorkerConfigPanelSettingsPromise = rpc_service.getWorkerConfigPanelSettings();
  const getOnboardingListPromise = rpc_service.GetOnboardingList();
  await rpc_service.updateTimezoneOffset();
  const controlIconTypePromise = rpc_service.getControlIconTypeList();
  const getMenuIconListPromise = rpc_service.getMenuIconList();
  
  const [
    sensorTypes,
    controlTypes,
    users,
    controls,
    bridgeDevices,
    bridgeDeviceTypes,
    gateways,
    cameras,
    cameraBrands,
    mediaFiles,
  ] = await Promise.all([
    sensorTypePromise,
    controlTypePromise,
    userPromise,
    controlPromise,
    bridgeDevicePromise,
    bridgeDeviceTypePromise,
    gatewayPromise,
    cameraPromise,
    cameraBrandPromise,
    mediaFilePromise,
  ]);
  
  const controlIconTypes = await controlIconTypePromise;
  const analogSensorTypeList = await getAnalogSensorTypeListPromise;
  const AllHardwareDeviceVersions = await getAllHardwareDeviceVersionsPromise;
  const messageList = await getMessageListPromise;
  const systemRestartSettings = await getSystemRestartPromise;
  const workerConfigPanelSettings = await getWorkerConfigPanelSettingsPromise;
  const onboardingList = await getOnboardingListPromise;
  const menuIconList = await getMenuIconListPromise;

  const [
    inputTypes,
    inputs,
    scenarios,
    scenarioTriggers,
    doors,
    doorBrands,
    intercoms,
    areas,
    medias,
    mediaInputs,
  ] = await Promise.all([
    inputTypePromise,
    inputPromise,
    scenarioPromise,
    scenarioTriggerPromise,
    doorPromise,
    doorBrandPromise,
    intercomPromise,
    areaPromise,
    mediaPromise,
    mediaInputPromise,
  ] as const);

  const [
    virtualControls,
    homepageItems,
    alarmState,
    soundState,
    settings,
    configs,
    locations,
    temperatureResponse,
    menuItems,
    stpUIs,
  ] = await Promise.all([
    virtualControlPromise,
    homepageItemPromise,
    alarmStatePromise,
    soundStatePromise,
    settingsPromise,
    configsPromise,
    locationPromise,
    temperaturePromise,
    menuItemPromise,
    stpUIPromise,
  ] as const);

  const [
    panelLanguage,
    languages,
    concierges,
    conciergeTypes,
    ifttt,
    screenState,
    logList,
    energyState,
  ] = await Promise.all([
    panelLanguagePromise,
    languagePromise,
    conciergePromise,
    conciergeTypePromise,
    iftttStatePromise,
    screenStatePromise,
    getLogListPromise,
    getEnergyStatePromise,
  ] as const);

  const [supervisorConfig, workerConfig] = await Promise.all([
    getSupervisorConfigPromise,
    getWorkerConfigPromise,
  ]);


  const [
    pinScreen,
    callList,
    mousePointer,
    favoritesItems,
    externalUsb,
    authorityGroupList,
    timezoneList,
    alarmTimer,
    callBlockList,
    boosterList,
  ] = await Promise.all([
    getScreenPinPromise,
    getCallListPromise,
    getMousePointerPromise,
    getHomepageItemsPromise,
    getExternalUsbPromise,
    getAuthorityGroupListPromise,
    getTimezonePromise,
    getAsyncAlarmTimerPromise,
    getSIPBlockedListPromise,
    getBoosterDeviceListPromise,
  ] as const);


    const [
      theme,
      lucentRGBSettings,
      SIPFormatTypeList,
      suntime,
      frameUIList
    ] = await Promise.all([
      getUIThemePromise,
      getLucentRGBSettingsPromise,
      getSIPFormatTypePromise,
      getSuntimePromise,
      getFrameUIListPromise
    ] as const);
  
  let languageKeys: { id: string, name: string }[] = [];
  for (const lang of languages as LanguageModel[]) {
    for (const [key, value] of Object.entries(lang.settings_variables.language_page)) {
      languageKeys.push({ id: key, name: value })
    }
    const flattenedTranslations: Record<string, string> = {};
    Object.keys(lang.settings_variables).forEach((prefix) => {
      const subSettings= lang.settings_variables[prefix];
      Object.keys(subSettings).forEach((suffix) => {
        const key = `${prefix}.${suffix}`;
        const value = subSettings[suffix];
        flattenedTranslations[key] = value;
      });
    });
    Object.assign(flattenedTranslations, lang.variables);
    i18n.addResources(lang.id, "translations", flattenedTranslations);
  }
  i18n.changeLanguage(panelLanguage) 
  const shouldReload = await shouldReloadPage(rpc_service, configs as ConfigModel)
  if (shouldReload) { window.location.reload(); return; }

  batch(() => {
    dispatch(setEntityListAction(sensorTypes, 'sensorType'));
    dispatch(setEntityListAction(controlTypes, 'controlType'));
    dispatch(setEntityListAction(users, 'user'));
    dispatch(setInitialEntityListAction(controls, 'control'));
    dispatch(setEntityListAction(bridgeDevices, 'bridgeDevice'));
    dispatch(setEntityListAction(bridgeDeviceTypes, 'bridgeDeviceType'));
    dispatch(setEntityListAction(gateways, 'gateway'));
    dispatch(setEntityListAction(cameras, 'camera'));
    dispatch(setEntityListAction(cameraBrands, 'cameraBrand'));
    dispatch(setEntityListAction(inputTypes, 'inputType'));
    dispatch(setEntityListAction(inputs, 'input'));
    dispatch(setEntityListAction(scenarios, 'scenario'));
    dispatch(setEntityListAction(scenarioTriggers, 'scenarioTrigger'));
    dispatch(setEntityListAction(doors, 'door'));
    dispatch(setEntityListAction(doorBrands, 'doorBrand'));
    dispatch(setEntityListAction(intercoms, 'intercom'));
    dispatch(setEntityListAction(areas, 'area'));
    dispatch(setEntityListAction(medias, 'media'));
    dispatch(setEntityListAction(mediaInputs, 'mediaInput'));
    dispatch(setEntityListAction(virtualControls, 'virtualControl'));
    dispatch(setEntityListAction(homepageItems, 'homepageItem'));
    dispatch(setEntityListAction(configs, 'config'));
    dispatch(setEntityListAction(locations, 'location'));
    dispatch(setEntityListAction(stpUIs, 'stpUI'));
    dispatch(setEntityListAction(languageKeys, 'language'));
    dispatch(setEntityListAction(concierges, 'concierge'));
    dispatch(setEntityListAction(controlIconTypes, 'controlIconType'));
    dispatch(setEntityListAction(conciergeTypes, 'conciergeType'));
    dispatch(setEntityListAction({ ...screenState, ...pinScreen }, "screenState"));
    dispatch(setEntityListAction(ifttt, 'ifttt'));
    dispatch(setEntityListAction(callList, "callList"));
    dispatch(setEntityListAction(authorityGroupList, "authorityGroup"));
    dispatch(setEntityListAction(alarmTimer, "alarmTimer"));
    dispatch(setEntityListAction(callBlockList, "callBlock"));
    dispatch(setEntityListAction(boosterList, "booster"));
    dispatch(setEntityListAction(SIPFormatTypeList, "sipFormatType"));
    dispatch(setEntityListAction(frameUIList, "frameUI"));
    dispatch(setEntityListAction(lucentRGBSettings, "lucentRGBSettings"));
    if (temperatureResponse != null) {
      dispatch(setTemperatureAction(temperatureResponse.icon, temperatureResponse.temperature));
    }
    dispatch(setEntityListAction(menuItems, 'menu'));
    dispatch(setDefaultAlarmStateAction(alarmState));
    dispatch(setSoundStateAction(soundState));
    dispatch(setSettingsAction(settings));
    dispatch(setMediaFileListAction(mediaFiles || []));
    dispatch(setApplicationLoaded());
    dispatch(setLogAction(logList || []))
    //dispatch(setConnectionIconsAction(connectionIcons))
    if (role === 'developer') {
      if (supervisorConfig) {
        dispatch(setSupervisorConfigListAction(supervisorConfig, "supConfig"));
      }
      if (workerConfig) {
        dispatch(setWorkerConfig(workerConfig));
      }
    }
    dispatch(setEnergyAnalyzer(energyState));
    dispatch(setMousePointerAction(mousePointer))
    dispatch(setHomepageItemsActions(favoritesItems))
    dispatch(setExternalUsbAction(externalUsb))
    dispatch(setTimezoneAction(timezoneList))
    dispatch(setSuntimeAction(suntime))
    dispatch(setThemeAction(theme))
    dispatch(setEntityListAction(analogSensorTypeList, "analogSensorType"));
    dispatch(setDeviceVersionListResponse(AllHardwareDeviceVersions));
    dispatch(setMessageNotification({ unread: messageList?.unread || 0 }));
    dispatch(setSystemRestartAction(systemRestartSettings));
    dispatch(setWorkerConfigPanelAction(workerConfigPanelSettings))
    dispatch(setOnboardingListAction(onboardingList))
    dispatch(setEntityListAction(menuIconList, "menuIcon"));
  });
}

function shouldReloadPage(rpc_service: RPCService, configs: ConfigModel) {

    // This function checks if the page should be reloaded based on the system 
    //configuration and version.

    // If advanced authorization is enabled, we need to reload the page if the 
    // preventReload flag is NOT set to true.

    //if (configs.advanced_authorization_status) {
      //  if (preventReload) {
        //    localStorage.setItem('preventReload', 'false');
          //  return false;
        //}
        // Before reloading the page, set the preventReload flag to true to prevent
        // the page from being reloaded again.
        //localStorage.setItem('preventReload', 'true');
        //return true;
    //}
    
    return rpc_service.getSystemInfo()
        .then(systemInfo => {
            if (latestVersion != null && systemInfo.version !== latestVersion) {
                localStorage.setItem('latestVersion', systemInfo.version);
                return true;
            }
            return false;
        })
        .catch(error => {
            console.error("Error fetching system info:", error);
            return false;
        });
    ;
}